/**
 * by constructing the types from a const array, we still get the benefits of a Type while
 * also having a data structure available at runtime.
 * https://stackoverflow.com/a/64174790/981556
 *
 * One use case is to allow dynamic controls in storybook.
 */

export const badgeSize = <const>['sm', 'base'];
export type BadgeSize = typeof badgeSize[number];

export const badgePalette = <const>['basic', 'dark', 'error', 'light', 'success', 'warning'];
export type BadgePalette = typeof badgePalette[number];
